const ENDPOINT = process.env.REACT_APP_API_ENDPOINT
export const USER_STATUS = `${ENDPOINT}/user_status`
export const HISTORY_API = `${ENDPOINT}/retrieve_chat_history`
export const CHAT_HISTORY = `${ENDPOINT}`

export default {}
